import { format } from "date-fns";
import { User } from "lucide-react";

interface PromoCodeUsage {
  id: string;
  user_id: string;
  discount_amount: number;
  created_at: string;
  profiles?: {
    email: string;
  };
}

interface PromoCodeUsageListProps {
  usages: PromoCodeUsage[];
  loading: boolean;
}

import { useTranslation } from "react-i18next";
// ... imports

// ... interfaces

export function PromoCodeUsageList({ usages, loading }: PromoCodeUsageListProps) {
  const { t } = useTranslation();

  if (loading) {
    return <div className="p-4 text-center">{t('common.loading')}</div>;
  }

  if (usages.length === 0) {
    return (
      <div className="p-12 text-center text-gray-400 border-2 border-dashed border-gray-300 rounded-xl">
        {t('admin.promoCodeDetail.noUsage')}
      </div>
    );
  }

  return (
    <div className="rounded-xl border-2 border-black bg-white shadow-[4px_4px_0_#000] overflow-hidden">
      <div className="bg-gray-50 border-b-2 border-black p-4 font-black">{t('admin.promoCodeDetail.usageHistory')}</div>
      <div className="divide-y-2 divide-black/5">
        {usages.map((usage) => (
          <div key={usage.id} className="flex items-center justify-between p-4 hover:bg-gray-50">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-black bg-[#4DA6FF]">
                <User className="h-5 w-5 text-white" />
              </div>
              <div>
                <p className="font-bold">{usage.profiles?.email || t('admin.content.unknownUser')}</p>
                <p className="text-xs text-gray-500">
                  ID: {usage.user_id.slice(0, 8)}...
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-black text-green-600">-${usage.discount_amount}</p>
              <p className="text-xs text-gray-500">
                {format(new Date(usage.created_at), 'yyyy/MM/dd HH:mm')}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
